let annexPolicyId: string | null = null;
let adjustedPremiumDifference: number | null = null;
let invoicedPremium: number | null = null;
let invoicedPremiumListener: ((value: number | null) => void) | null = null;

export const setAnnexPolicyId = (policyId: string | null) => {
    annexPolicyId = policyId;
};

export const getAnnexPolicyId = () => annexPolicyId;

export const isAnnexMode = () => !!annexPolicyId;

export const setAdjustedPremiumDifference = (value: number | null) => {
    adjustedPremiumDifference = value;
};

export const getAdjustedPremiumDifference = () => adjustedPremiumDifference;

export const getInvoicedPremium = () => invoicedPremium;

export const setInvoicedPremium = (value: number | null) => {
    invoicedPremium = value;
    invoicedPremiumListener?.(value);
};

export const subscribeInvoicedPremium = (listener: (value: number | null) => void) => {
    invoicedPremiumListener = listener;
    listener(invoicedPremium);
    return () => {
        if (invoicedPremiumListener === listener) {
            invoicedPremiumListener = null;
        }
    };
};

export const parseKadiferencePrimi = (metadata: { KADIFERENCEPRIMI?: unknown } | null | undefined): number | null => {
    const raw = metadata?.KADIFERENCEPRIMI;
    if (raw === undefined || raw === null || raw === '') return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
};

export const resetAnnexPremiumFields = () => {
    adjustedPremiumDifference = null;
    invoicedPremium = null;
    invoicedPremiumListener?.(null);
};
